<template>
  <v-footer
    padless
    :color="footerTop"
  >
    <div style="width: 100%; text-align: center;">
      <v-btn
        v-for="link in links"
        :key="link"
        text
        rounded
        @click="eventHandler(link)"
        :color="footerTopFont"
        :style="'background-color: ' + footerButtonBG + ';'"
        class="ma-2"
      >
        {{ link }}
      </v-btn>
    </div>
    <div :style="'width: 100%; text-align: center; background-color: ' + footerBottom + ';'" class="pa-3">
      <span :style="'color: ' + footerBottomFont + ';'">
        {{ new Date().getFullYear() }} — <strong>Darktheme</strong>
      </span>
    </div>
  </v-footer>
</template>

<script>
export default {
  props: {
    footerTop: {
      type: String,
      required: true
    },
    footerTopFont: {
      type: String,
      required: true
    },
    footerBottom: {
      type: String,
      required: true
    },
    footerBottomFont: {
      type: String,
      required: true
    },
    footerButtonBG: {
      type: String,
      required: true
    }
  },
  data: () => ({
    links: [
      'Toggle Darkmode',
      'Blue',
      'Red',
      'Purple',
      'Green',
      'Yellow',
    ],
  }),
  methods: {
    eventHandler(link) {
      Event.$emit(link);
    }
  }
}
</script>

<style>
  .colBG {
    background-color: #ECEFF1;
  }
</style>